<!--<app-breadcrumb [title]="'Списък с Проблеми'"
                [items]="['issueViewer']"
                [active_item]="'issue-list'"></app-breadcrumb>-->

<div class="container" style="padding-top:40px;">
  <div class="left-content">
    <app-issue-card *ngFor="let issue of issueCardModels; let i = index"
                    [issueCard]="issue"
                    [ngClass]="{'selected-card': selectedIssueId === i}"
                    (click)="selectIssue(i)">
    </app-issue-card>
  </div>
  <div class="right-content">
    <app-issue-details [issue]="getSelectedIssue()" />
  </div>
</div>
